/**
 * URL Input with intent selector for Step 1
 */

import { Input } from "@/components/ui/input";
import { urlIntentOptions } from "./constants";
import ListingDetailsForm from "@/components/ListingDetailsForm";

export function UrlInput({
  inputUrl,
  setInputUrl,
  urlIntent,
  setUrlIntent,
  showListingDetails,
  setShowListingDetails,
  listingType,
  setListingType,
  listingDetails,
  setListingDetails,
  textPosition,
  setTextPosition
}) {
  return (
    <div className="space-y-4">
      <div>
        <label className="text-sm font-medium mb-2 block">Paste your URL</label>
        <Input
          type="url"
          placeholder="https://yourstore.com/product or any article URL"
          value={inputUrl}
          onChange={(e) => setInputUrl(e.target.value)}
          className="input-base text-base py-3"
          autoFocus
          data-testid="input-url"
        />
        <p className="text-xs text-viraly-muted mt-2">
          Works with blogs, product pages, Amazon, Shopify, and social posts
        </p>
      </div>
      
      {/* URL Intent Selector */}
      <div className="p-4 rounded-xl bg-white/5 border border-white/10">
        <label className="text-sm font-medium mb-3 block">What would you like to create?</label>
        <div className="grid grid-cols-2 gap-2">
          {urlIntentOptions.map((intent) => (
            <button
              key={intent.id}
              type="button"
              onClick={() => {
                setUrlIntent(intent.id);
                if (intent.id === "custom") {
                  setShowListingDetails(true);
                }
              }}
              className={`p-3 rounded-lg text-left transition-all ${
                urlIntent === intent.id
                  ? "bg-viraly-orange/20 border-viraly-orange border"
                  : "bg-white/5 border-white/10 border hover:bg-white/10"
              }`}
              data-testid={`url-intent-${intent.id}`}
            >
              <div className="flex items-center gap-2 mb-1">
                <span>{intent.icon}</span>
                <span className="text-sm font-medium">{intent.label}</span>
              </div>
              <p className="text-xs text-viraly-muted">{intent.desc}</p>
            </button>
          ))}
        </div>
      </div>
      
      {/* Listing Details for "custom" intent */}
      {(urlIntent === "custom" || showListingDetails) && (
        <ListingDetailsForm
          showListingDetails={showListingDetails || urlIntent === "custom"}
          setShowListingDetails={setShowListingDetails}
          listingType={listingType}
          setListingType={setListingType}
          listingDetails={listingDetails}
          setListingDetails={setListingDetails}
          textPosition={textPosition}
          setTextPosition={setTextPosition}
        />
      )}
      
      {urlIntent !== "custom" && !showListingDetails && (
        <button
          type="button"
          onClick={() => setShowListingDetails(true)}
          className="text-xs text-viraly-orange hover:underline"
        >
          + Add listing details for more control
        </button>
      )}
    </div>
  );
}
